"use client";

import * as React from "react";
import { useSize } from "../hooks/useSize";

type Size = { width: number; height: number };

const style: React.CSSProperties = {
  display: "flex",
  flex: "1 0 0",
  flexDirection: "column",
};

interface Props {
  children: (size: Size) => React.ReactNode;
  className?: string;
}

export const AutoSizer = React.memo(function AutoSizer({
  children,
  className,
}: Props) {
  const containerRef = React.useRef<HTMLDivElement | null>(null);
  const containerSize = useSize(containerRef);

  return (
    <div ref={containerRef} style={style} className={className}>
      {containerSize &&
        containerSize.width > 0 &&
        containerSize.height > 0 &&
        children(containerSize)}
    </div>
  );
});

interface SingleDimensionAutoSizerProps {
  children: (size: number) => React.ReactNode;
  dimension: "width" | "height";
  className?: string;
}

export const SingleDimensionAutoSizer = React.memo(
  function SingleDimensionAutoSizer({
    children,
    dimension,
    className,
  }: SingleDimensionAutoSizerProps) {
    const containerRef = React.useRef<HTMLDivElement | null>(null);
    const containerSize = useSize(containerRef, dimension);

    return (
      <div ref={containerRef} style={style} className={className}>
        {containerSize &&
          containerSize[dimension] > 0 &&
          children(containerSize[dimension])}
      </div>
    );
  }
);
